<template>
  <div id="MainWholesalers">
    <NavBarWholesalers />

    <router-view class="container-catalogo-views" />

    <div
      v-if="showMessage"
      :class="`notifications ${openMessage ? 'opened' : ''} ${$route.fullPath !== '/home' ? 'not-home' : ''}`"
    >
      <v-alert
        v-model="openMessage"
        class="ma-0"
        :color="colorMessage"
        :icon="iconMessage"
        dark
        dismissible
      >
        {{ message }}
      </v-alert>

      <v-btn
        v-if="!openMessage"
        class="ma-1"
        small
        fab
        dark
        elevation="2"
        :color="colorMessage"
        @click="openMessage = true"
      >
        <v-icon>{{ iconMessage }}</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
// Vue
import { mapGetters, mapMutations } from 'vuex'

// Mixins
import SOCKET from '../../minixs/socket'
import WHOLESALERS from '../../minixs/wholesalers'

// Components
import NavBarWholesalers from '../../components/wholesalers/NavBarWholesalers.vue'

export default {
  name: 'MainWholesalers',
  components: {
    NavBarWholesalers
  },
  mixins: [
    SOCKET,
    WHOLESALERS
  ],
  data () {
    return {
      showMessage: false,
      openMessage: false,
      message: '',
      colorMessage: 'primary',
      iconMessage: 'mdi-alert-circle-outline'
    }
  },
  computed: {
    ...mapGetters({
      userData: 'auth/userData'
    })
  },
  created () {
    this.ejectSocket()
  },
  mounted () {
    if (this.userData?.rol !== 4) {
      if (this.$root.socket) this.$root.socket.disconnect()
      this.$router.push({ name: 'Login' })
      this.logoutUser()
      return
    }
    this.getTicketsAndSiteWhosaler()
    this.getMessage()
  },
  methods: {
    ...mapMutations({
      setLoadingMainApp: 'globalStates/setLoadingMainApp',
      setPlacesAvailable: 'wholesaler/setPlacesAvailable',
      setTicketsAvailable: 'wholesaler/setTicketsAvailable',
      logoutUser: 'auth/logoutUser'
    }),
    getTicketsAndSiteWhosaler: function () {
      this.setPlacesAvailable([])
      this.setTicketsAvailable([])
      this.setLoadingMainApp(true)

      this.$root.post('/wholesalers/getTicketsAndPlace')
        .then(
          (response) => {
            const data = response.data
            if (data.success === 'FALSE') {
              this.$swalAlert('error', 'Error', data.message)
              return
            }

            const placesAvailable = []
            const ticketsAvailable = []

            data.forEach(element => {
              
              const { sitio, name, img, nombre,Ffin } = element
              let _array = JSON.parse(element.ticketsForSelectedPlace)

              const { idTicket, idTicketDate, active, alias, alias2, id, costo, npool, persontype, Fini, NTARIFBLATTNR, NTARIFBLATTGUELTNR } = JSON.parse(element.ticketsForSelectedPlace)
              const placeExist = placesAvailable.find((item) => item.id === sitio)

              if (!placeExist) placesAvailable.push({ id: sitio, name, img, cantidad: 0 })

              ticketsAvailable.push({
                id,
                sitio,
                name: nombre,
                alias,
                alias2,
                costo:0,
                npool,
                persontype,
                ini: Fini,
                fin: Ffin,
                cantidad: 0,
                firtsPress: true,
                NTARIFBLATTNR,
                NTARIFBLATTGUELTNR,
                idTicket,
                idTicketDate,
                active,
                ticketsForSelectedPlace: JSON.parse(element.ticketsForSelectedPlace)
              })
            })

            this.setPlacesAvailable(placesAvailable)
            this.setTicketsAvailable(ticketsAvailable)
          }
        ).finally(() => { this.setLoadingMainApp(false) })
    },
    getMessage: async function () {
      const { data } = await this.$root.post('/wholesalers/message')

      this.showMessage = !!data.show || false
      this.openMessage = !!data.open || false
      this.message = data.message || ''
      this.colorMessage = data.color || 'primary'
      this.iconMessage = data.icon || 'mdi-alert-circle-outline'
    }
  }
}
</script>

<style scoped>
.notifications{
  position: fixed;
  bottom: 40px;
  left: 0;
  right: 0;
  z-index: 2;
  width: fit-content;
  transition: bottom 0.2s ease-in-out;
}

.notifications.not-home{
  bottom: 0;
}

.notifications.opened{
  width: 100%;
}

.container-catalogo-views {
  margin-top: var(--h-navbar) !important;
  max-height: calc(100vh - var(--h-navbar));
  overflow: auto;
}
</style>
